import { MenuComedorService } from './../../services/menu-comedor.service';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { menuComedorAll } from './menu-comedor.selectors';
import { Action, Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { MENU_COMEDOR_SEDE, MENU_COMEDOR_TURNO, MenuComedorSedeRecord, MenuComedorSedeStatus, MenuComedorStatus } from 'src/common/menuComedor';
import { menuComedorCancelled, menuComedorLoaded, menuComedorRequested } from './menu-comedor.actions';
import { ToastService } from 'src/app/services/toast.service';


@Injectable()
export class MenuComedorEffects {

	loadMenuComedorRequested = createEffect( () => {
		return this.actions$.pipe(
			ofType( menuComedorRequested ),
			withLatestFrom( this.store.select( menuComedorAll ) ),
			switchMap( ([action, localStatus]) => {
				// Obtengo los status remotos de todas las sedes
				return this.service.findMenuStatus().pipe(
					map( remoteStatus => ({ localStatus, remoteStatus }) ),
					catchError( error => of({ localStatus, remoteStatus: null }) )
				)
			}),
			switchMap( data => {
				let resultAction: Observable<Action>;

				if( data.remoteStatus == null || data.remoteStatus.length == 0 ) {
					// Si no se pudo obtener el status del menú para ninguna sede =>
					// => puede ser que todavía no esté asignado el menú y por consiguiente tampoco se conoce el status.
					// Se indica en el action de respuesta que es necesario realizar un clear de todos los menús
					resultAction = of( menuComedorCancelled( { clear: true } ) );
				} else {
					// Para todas las sedes comparo el local status vs remote status =>
					// => guardo las sedes que tienen un remote fecha posterior al local fecha, o un remote idMenu distinto a local idMenu
					let newSedeStatus: MenuComedorSedeStatus[] = Object.keys( MENU_COMEDOR_SEDE )
						.filter( value => isNaN( Number( value ) ) )	// este filtro es para quedarme con los nombres del enumerado
						.filter( sede => {
							let result: boolean = false;
							let local: MenuComedorSedeRecord = data.localStatus.find( status => status.sede.toString() == sede );
							let remote: MenuComedorSedeStatus = data.remoteStatus.find( status => status.sede.toString() == sede );
							// Puede ser que en data.remoteStatus estén los status de todas las sedes, o de alguans sedes =>
							// => por eso valido que remote sea distinto a null
							if( remote ) {
								let lstatus: MenuComedorStatus = local?.status;
								let rstatus: MenuComedorStatus = remote.status;
								// Para comparar si bien debería utilizar el local.fecha < remote.fecha, utilizo el operador !=
								result = lstatus?.fecha == null || lstatus.fecha.getTime() != rstatus.fecha.getTime() ||
									lstatus?.idMenu == null || lstatus.idMenu != rstatus.idMenu ||
									lstatus?.turno == null || lstatus.turno != rstatus.turno;
							}
							return result;
						})
						.map( sede => data.remoteStatus.find( status => status.sede.toString() == sede ) );

					// Busco que sedes no tienen remote status => son aquellas sedes que no tienen menú asignado
					let sedesWithoutMenu: MENU_COMEDOR_SEDE[] = Object.keys( MENU_COMEDOR_SEDE )
						.filter( value => isNaN( Number( value ) ) )	// este filtro es para quedarme con los nombres del enumerado
						.filter( sede => data.remoteStatus.find( status => status.sede == sede ) == null )
						.map( sede => MENU_COMEDOR_SEDE[sede] );						
					
					if( newSedeStatus?.length > 0 ) {
						// Busco los menús para las sedes que se encuentran en newSedeStatus
						let sedesToFindMenu: MENU_COMEDOR_SEDE[] = newSedeStatus.map( sedeStatus => sedeStatus.sede );
						resultAction = this.service.findMenu( sedesToFindMenu )
							.pipe(
								map( menusSede => {
									// A cada menú retornado le agrego el status actualizado de la sede
									let menus: MenuComedorSedeRecord[] = menusSede.map( menu => {
										let sedeStatusFound: MenuComedorSedeStatus = newSedeStatus.find( sedeStatus => sedeStatus.sede == menu.sede );
										// Si encuentro el status para el menú => agrego la fecha y el idMenu
										if( sedeStatusFound )
											menu.status = sedeStatusFound.status;
										return menu;
									});
									return menuComedorLoaded( { menus, sedesWithoutMenu } );
								}),									
								catchError( error => {
									this.toastService.danger( "No se pudo obtener el menú comedor" );
									return of( menuComedorCancelled( { clear: sedesToFindMenu } ) );
								})
							);
					} else {
						// Este caso se da cuando no hay cambios de menú en todas las sedes
						resultAction = of( menuComedorCancelled( { clear: sedesWithoutMenu } ) );
					}
				}
				return resultAction;
			})
		);
	});


	constructor( private actions$: Actions, private store: Store<AppState>, private service: MenuComedorService, private toastService: ToastService  ) {
	}

}